    (() => {
    if (window.masmusculoCollapsibleTabsInitialized) return;
    window.masmusculoCollapsibleTabsInitialized = true;

    const GROUP_SELECTOR = '[data-product-collapsible-group]';

    const init = () => {
    document.addEventListener('variant:change', async (event) => {
    const variantId = event?.detail?.variant?.id;
    if (!variantId) return;

    const groups = Array.from(document.querySelectorAll(GROUP_SELECTOR));
    if (!groups.length) return;

    const openEntries = groups.flatMap(group =>
        Array.from(
            group.querySelectorAll('[data-product-collapsible-entry] details[open]')
        ).map(details => details.closest('[data-product-collapsible-entry]').dataset.productCollapsibleEntry)
    );

    const currentVariantId = groups[0].dataset.productCollapsibleVariant;
    if (currentVariantId && String(currentVariantId) === String(variantId)) return;

    const sectionEl = groups[0].closest('.shopify-section');
    if (!sectionEl) return;

    const sectionId =
    sectionEl.dataset.sectionId ||
    (sectionEl.id ? sectionEl.id.replace('shopify-section-', '') : '');

    let url = `${window.location.pathname}?variant=${variantId}`;
    if (sectionId) url += `&section_id=${sectionId}`;

    try {
    const findSection = (root) =>
    root.querySelector(`#${sectionEl.id}`) ||
    (sectionId ? root.querySelector(`[data-section-id="${sectionId}"]`) : null);

    // Rendimiento (INP): product-info.js ya ha descargado y analizado esta misma seccion para la
    // variante. Se reutiliza (clonada, para no tocar su documento) y solo se pide de nuevo si no viene.
    let replacementSection = null;
    const sharedHtml = event?.detail?.html;
    if (sharedHtml && typeof sharedHtml.querySelector === 'function') {
    const sharedSection = findSection(sharedHtml);
    if (sharedSection && sharedSection.querySelector(GROUP_SELECTOR)) {
    replacementSection = sharedSection.cloneNode(true);
    }
    }

    if (!replacementSection) {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), 5000);

    const response = await fetch(url, { signal: controller.signal });
    window.clearTimeout(timeoutId);

    if (!response.ok) return;

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    replacementSection = findSection(doc);
    }

    if (!replacementSection) return;

    groups.forEach((group) => {
    const key = group.dataset.productCollapsibleGroup;
    if (!key) return;

    const match = replacementSection.querySelector(
    `${GROUP_SELECTOR}[data-product-collapsible-group="${key}"]`
    );

    if (match) {
        // Judge.me widgets use data-auto-install="false" and are decorated once by
        // Judge.me's own script. Swapping in the freshly-fetched markup would replace the
        // already-decorated nodes with un-decorated copies that never get re-initialized,
        // so graft the current (decorated) nodes onto the incoming markup instead.
        ['#judgeme_product_reviews', '.jdgm-preview-badge'].forEach((selector) => {
            const currentWidget = group.querySelector(selector);
            const incomingWidget = match.querySelector(selector);
            if (currentWidget && incomingWidget) {
                incomingWidget.replaceWith(currentWidget);
            }
        });

        group.replaceWith(match);
        match
            .querySelectorAll('[data-product-collapsible-entry]')
            .forEach(entry => {
                if (openEntries.includes(entry.dataset.productCollapsibleEntry)) {
                    entry.querySelector('details')?.setAttribute('open', '');
                }
            });
    }
});
} catch (error) {
    console.error('Failed to refresh collapsible tabs:', error);
}
});
};

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
    init();
}
})();
